export class DashboardCaseProduct {
  productName: string;
  isAlert: boolean;
  isClosed: boolean;
}
